import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.NEW_PASSWORD_PAGE]: {
    [ROLE.FORM]: [ELEMENT.PASSWORD],
  },
} as TValidTestId;
